/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/array-extends.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Enumerable = require("linq");
Array.prototype.Enumerable = (/**
 * @template T
 * @return {?}
 */
function () {
    /** @type {?} */
    var array = this;
    return Enumerable.from(array);
});
var ArrayExtends = /** @class */ (function () {
    function ArrayExtends() {
    }
    return ArrayExtends;
}());
export { ArrayExtends };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXktZXh0ZW5kcy5qcyIsInNvdXJjZVJvb3QiOiJuZzovL3Zlc3RhLyIsInNvdXJjZXMiOlsibGliL3NlcnZpY2UvYXJyYXktZXh0ZW5kcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7SUFBSSxVQUFVLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQztBQUVoQyxLQUFLLENBQUMsU0FBUyxDQUFDLFVBQVU7Ozs7QUFBRzs7UUFDckIsS0FBSyxHQUFhLElBQUk7SUFDMUIsT0FBTyxVQUFVLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2xDLENBQUMsQ0FBQSxDQUFBO0FBRUQ7SUFBQTtJQUEwQixDQUFDO0lBQUQsbUJBQUM7QUFBRCxDQUFDLEFBQTNCLElBQTJCIiwic291cmNlc0NvbnRlbnQiOlsidmFyIEVudW1lcmFibGUgPSByZXF1aXJlKFwibGlucVwiKTtcclxuXHJcbkFycmF5LnByb3RvdHlwZS5FbnVtZXJhYmxlID0gZnVuY3Rpb24gPFQ+KCkge1xyXG4gICAgbGV0IGFycmF5OiBBcnJheTxUPiA9IHRoaXM7XHJcbiAgICByZXR1cm4gRW51bWVyYWJsZS5mcm9tKGFycmF5KTtcclxufVxyXG5cclxuZXhwb3J0IGNsYXNzIEFycmF5RXh0ZW5kc3t9XHJcbiJdfQ==